import axios from "axios";
import { REACT_BACKEND_URL } from "urls";

const restClient = axios.create({
  baseURL: REACT_BACKEND_URL,
});

restClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    const locale = localStorage.getItem("locale") || "en";

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    // config.headers["ngrok-skip-browser-warning"] = "true";

    if (!config.params) {
      config.params = {};
    }

    config.params.locale = locale;

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default restClient;
